// extracted by mini-css-extract-plugin
module.exports = {"empty":"style_empty__KGULR","empty-icon":"style_empty-icon__6JA1F","empty-title":"style_empty-title__4lHVJ","empty-description":"style_empty-description__1b0zJ"};